import { Capsule } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import ImportedJourneySummary from '../../_components/imported-journey-summary/ImportedJourneySummary';
import { useSelector } from '../../store/AppStore';
import classes from './ImportFiles.module.scss';

const ImportFiles = () => {
  const { t: translate } = useTranslation();
  const { config } = useSelector(
    (state) => state.ImportJourneySummaryReducer
  );

  const STATUS_CLASSTYPES = {
    SUCCESS: 'active',
    FAILED: 'returned',
    INACTIVE: 'inactive'
  };

  const renderConfigValue = (status: string, textStyle: string) => (
    <div className={classes['pill-text']}>
      <Capsule className={textStyle} text={status.charAt(0).toLocaleUpperCase() + status.slice(1).toLocaleLowerCase()} />
    </div>
  );

  return (
    <>
      <div className={classes['import-files-notification-header']}>
        <p className={classes['import-files-notification-header-text']}>
          {translate('journey_import_summary.imported_configurations')}
        </p>
        <div className={classes['import-files-notification-config-details']}>
          <div className={classes['import-files-notification-config-detail']}>
            <div className={classes['import-files-notification-config-detail-key']}>
              {translate('journey_import_summary.source_env')}
            </div>
            <div className={classes['import-files-notification-config-detail-value']}>
              {renderConfigValue(config?.sourceEnv, STATUS_CLASSTYPES.INACTIVE)}
            </div>
          </div>
        </div>
        <div className={classes['config-count-summary']}>
          <p className={classes['config-count-summary-text']}>{renderConfigValue(config?.totalSuccessRecordsCount?.toLocaleString(), STATUS_CLASSTYPES.SUCCESS)} {translate('journey_import_summary.success_config_count')} </p>
          <p className={classes['config-count-summary-text']}> {renderConfigValue(config?.totalFailureRecordsCount?.toLocaleString(), STATUS_CLASSTYPES.FAILED)} {translate('journey_import_summary.failed_config_count')}</p>

        </div>
      </div>
      {config?.records
        && <ImportedJourneySummary records={config?.records} />}
    </>
  );
};

export default ImportFiles;
